<p>customer-brand-setup works!</p>
